import { render, staticRenderFns } from "./SystemAdmin.vue?vue&type=template&id=0be13f8f&scoped=true"
import script from "./SystemAdmin.vue?vue&type=script&lang=js"
export * from "./SystemAdmin.vue?vue&type=script&lang=js"
import style0 from "./SystemAdmin.vue?vue&type=style&index=0&id=0be13f8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be13f8f",
  null
  
)

export default component.exports